import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../ui/Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-153">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 pointer-events-none" data-id="element-154">
          <div className="max-w-4xl mx-auto bg-black border border-gold-hairline border-t-gold/30 shadow-editorial-dark p-4 rounded-sm flex flex-col sm:flex-row items-center justify-between gap-4 pointer-events-auto" data-id="element-155">
            <div className="hidden sm:block" data-id="element-156">
              <div className="text-bone font-serif font-medium text-lg" data-id="element-157">
                The Ultimate Auction Secrets Blueprint 2026
              </div>
              <div className="text-gold text-sm font-semibold tracking-wide mt-1" data-id="element-158">
                Just $6.36
              </div>
            </div>

            <Button className="w-full sm:w-auto py-3 px-6 text-base" data-id="element-159">
              Get The Blueprint Now
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}